export const enum PATCH_STATUS {
  "ACTIVE_MONITORING" = "ACTIVE_MONITORING",
  "NO_TRANSMISSION" = "NO_TRANSMISSION",
  "NO_ACTIVE_DEVICE" = "NO_ACTIVE_DEVICE",
  "RETURN_DEVICE" = "RETURN_DEVICE",
  "SWITCH_PATCH" = "SWITCH_PATCH",
  "PENDING_TRANSMISSION" = "PENDING_TRANSMISSION",
}
